import {AfterViewInit, Component, Directive, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {environment} from '../../../../../environments/environment';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ConfirmDialogComponent} from '../../../dialog/confirmdialog.component';
import {language} from '../../../../language/vn';
import {YeuCau} from '../../../../models/yeucau/yeucau';
import {YeuCauService} from '../../../../service/yeucau/service-yeucau';
import {EditYeuCauComponent} from '../yeucaugui/edit.component';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {FormatService} from '../../../../service/format/service-format';
import {DatePipe} from '@angular/common';

@Component({
  templateUrl: './yeucaudangsoan.component.html',

})
export class YeuCauDangSoanComponent implements OnInit, AfterViewInit {
  @ViewChild('largeModal')
  public largeModal: ModalDirective;
  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public configToolbar: Object = environment.configToolbar;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public isRefresh: boolean = false;
  public dataList: YeuCau[];
  public submitValidate = false;
  public srChuDe: string = '';
  public uploadUrl: String;
  public deleteUrl: String;
  public fileLists: Object[];
  public srStatus: number[] =[environment.soanthao ];
  public staffId: number= Sessioncommand.staffId;
  public srFromDate: Date;
  public srToDate: Date;
  constructor(
    public yeuCauService: YeuCauService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public formatService: FormatService,
    public datePipe: DatePipe

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.search();

  }

  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }

  edit(id: number) {
    const modalEdit = this.bsModalService.show(EditYeuCauComponent, {class: 'modal-lg'});
    (<EditYeuCauComponent>modalEdit.content).edit(
      id
    );
    (<EditYeuCauComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();
      }
    });

  }
  search()
  {
    const status: String = this.srStatus.join() ;
    this.yeuCauService.findAllByPaging(this.srChuDe,status, this.staffId, -1,
      this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy'),
      this.datePipe.transform(this.srToDate, 'MM/dd/yyyy'),
      this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.yeuCauService.getCountByKeyword(this.srChuDe, status, this.staffId, -1,
      this.datePipe.transform(this.srFromDate, 'MM/dd/yyyy'),
      this.datePipe.transform(this.srToDate, 'MM/dd/yyyy')
      ).subscribe(recordCount => this.totalItems = recordCount);
  }


  deleteItem(id: number)
  {
    this.yeuCauService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();
        Sessioncommand.giaiQuyetSuVuStatus = 0;

      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

